<template>
	<div>
		<q-table
			:data="company_selected"
			:columns="columns_company_selected"
			:pagination.sync="server_pagination_selected"
			@request="request_selected"
			:loading="loading"
			selection="multiple"
			:selected.sync="company_branches_remove"
			:filter="filter_selected"
			row-key="id"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5, 10, 50, 100]"
			binary-state-sort
		>
			<template slot="top" slot-scope="props">
				<q-search
					v-model="filter_selected"
					icon="far fa-search"
					:placeholder="$t('search')"
					:debounce="500"
				/>
				<div class="col" />
				<q-btn
					color="positive"
					icon="far fa-plus"
					:label="$t('add')"
					@click="openModal()"
				/>
				<q-btn
					class="q-ml-sm"
					color="negative"
					v-if="company_branches_remove.length > 0"
					icon="far fa-trash-alt"
					:label="$t('remove')"
					@click="removeStore()"
				/>
			</template>

			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th auto-width>
					<q-checkbox v-model="props.selected" indeterminate-value="some" />
				</q-th>

				<q-th v-for="col in props.cols" :key="col.name" :props="props">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<q-tr slot="body" slot-scope="props" :props="props">
				<q-td auto-width>
					<q-checkbox color="primary" v-model="props.selected" />
				</q-td>

				<q-td key="id" :props="props">
					{{ props.row.id }}
				</q-td>

				<q-td key="name" :props="props">
					{{ props.row.name }}
				</q-td>

				<q-td key="branch_type_name" :props="props">
					{{ props.row.branch_type_name_a }}
				</q-td>

				<q-td key="company_name" :props="props">
					{{ props.row.company_name }}
				</q-td>

				<q-td key="company_type" :props="props">
					{{ props.row.company_type }}
				</q-td>
			</q-tr>
		</q-table>

		<q-modal
			v-model="modal_company"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="modal_company = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('add_new_branch') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<q-table
						:data="company"
						:columns="columns"
						:pagination.sync="server_pagination"
						@request="request"
						:loading="loading"
						selection="multiple"
						:selected.sync="company_branches_add"
						:filter="filter"
						row-key="id"
						:no-data-label="$t('no_data_avaliable')"
						:no-results-label="$t('no_results_found')"
						:loading-label="$t('loading_data')"
						:rows-per-page-label="$t('items_per_page')"
						:rows-per-page-options="[5, 10, 50, 100]"
						binary-state-sort
					>
						<template slot="top" slot-scope="props">
							<q-search
								v-model="filter"
								icon="far fa-search"
								:placeholder="$t('search')"
								:debounce="500"
							/>
							<div class="col" />
							<q-btn
								color="positive"
								v-if="company_branches_add.length > 0"
								icon="far fa-save"
								:label="$t('add')"
								@click="saveStore()"
							/>
						</template>

						<q-tr slot="header" slot-scope="props" :props="props">
							<q-th auto-width>
								<q-checkbox v-model="props.selected" indeterminate-value="some" />
							</q-th>

							<q-th v-for="col in props.cols" :key="col.name" :props="props">
								{{ $t(col.label) }}
							</q-th>
						</q-tr>

						<q-tr slot="body" slot-scope="props" :props="props">
							<q-td auto-width>
								<q-checkbox color="primary" v-model="props.selected" />
							</q-td>

							<q-td key="id" :props="props">
								{{ props.row.id }}
							</q-td>

							<q-td key="name" :props="props">
								{{ props.row.name }}
							</q-td>

							<q-td key="branch_type_name" :props="props">
								{{ props.row.branch_type_name }}
							</q-td>

							<q-td key="company_name" :props="props">
								{{ props.row.company_name }}
							</q-td>

							<q-td key="company_type" :props="props">
								{{ props.row.company_type }}
							</q-td>
						</q-tr>
					</q-table>
				</div>
			</q-modal-layout>
		</q-modal>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="far fa-chevron-left"
					@click="$router.push({ name: 'campaigns' })"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as moment from 'moment'

export default {
	name: 'Company-Branches',

	data() {
		return {
			company_branches_remove: [],
			server_pagination_selected: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				descending: false,
				sortBy: null,
			},
			company_selected: [],
			columns_company_selected: [
				{
					name: 'id',
					required: true,
					label: '#',
					align: 'left',
					field: 'id',
					sortable: true,
				},
				{
					name: 'name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'name',
					sortable: true,
				},
				{
					name: 'branch_type_name',
					required: true,
					label: 'branch_type',
					align: 'left',
					field: 'branch_type_name',
					sortable: true,
				},
				{
					name: 'company_name',
					required: true,
					label: 'company_name',
					align: 'left',
					field: 'company_name',
					sortable: true,
				},
				{
					name: 'company_type',
					required: true,
					label: 'company_type',
					align: 'left',
					field: 'company_type',
					sortable: true,
				},
			],
			filter_selected: '',
			loading: false,
			filter: '',
			modal_company: false,
			stores: [],
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				descending: false,
				sortBy: null,
			},
			company: [],
			columns: [
				{
					name: 'id',
					required: true,
					label: '#',
					align: 'left',
					field: 'id',
					sortable: true,
				},
				{
					name: 'name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'name',
					sortable: true,
				},
				{
					name: 'branch_type_name',
					required: true,
					label: 'branch_type',
					align: 'left',
					field: 'branch_type_name',
					sortable: true,
				},
				{
					name: 'company_name',
					required: true,
					label: 'company_name',
					align: 'left',
					field: 'company_name',
					sortable: true,
				},
				{
					name: 'company_type',
					required: true,
					label: 'company_type',
					align: 'left',
					field: 'company_type',
					sortable: true,
				},
			],
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			num_rows: 'datatable/num_rows',
			id: 'campaigns/id',
			status: 'campaigns/status',
			title: 'campaigns/title',
			sub_title: 'campaigns/sub_title',
			description: 'campaigns/description',
			campaign_url: 'campaigns/campaign_url',
			image: 'campaigns/image',
			area: 'campaigns/areas',
			profile: 'campaigns/profiles',
			start_date: 'campaigns/start_date',
			end_date: 'campaigns/end_date',
			company_branches: 'campaigns/company_branches',
			brands: 'campaigns/brands',
			product_types: 'campaigns/product_types',
			products: 'campaigns/products',
			rewards: 'campaigns/rewards',
			allow_sells: 'campaigns/allow_sells',
			training_kpi_points: 'campaigns/training_kpi_points',
			training_non_kpi_points: 'campaigns/training_non_kpi_points',
			image_banner: 'campaigns/image_banner',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},

		company_branches_add: {
			get() {
				return this.stores
			},

			set(val) {
				this.stores = []
				val.map((e) => {
					this.stores.push(e)
				})
			},
		},

		disableData() {
			if (this.status == 1 || this.status == 4) return true
			else return false
		},
	},

	methods: {
		request_selected({ pagination }) {
			this.loading = true
			this.server_pagination_selected = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination_selected.rowsPerPage,
				page: this.server_pagination_selected.page,
				search: this.filter_selected,
				ordering: order_by,
				is_selected: true,
			}

			this.savePagination()

			this.$axios
				.get(
					`/admin_rewards/campaigns/${this.id}/company_branches/?` +
						this.$qs.stringify(data),
					this.getHeader
				)
				.then((response) => {
					this.server_pagination_selected.rowsNumber = response.data.count
					this.company_selected = []
					this.company_selected = response.data.results.map((e) => ({
						...e,
						branch_type_name_a: e.branch_type_name,
					}))
					this.loading = false
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
		},

		request({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				search: this.filter,
				ordering: order_by,
				is_selected: false,
			}

			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])

			this.$axios
				.get(
					`/admin_rewards/campaigns/${this.id}/company_branches/?` +
						this.$qs.stringify(data),
					this.getHeader
				)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count
					this.company = []
					this.company = response.data.results
					this.loading = false
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
		},

		openModal() {
			this.server_pagination.rowsPerPage = this.num_rows
			this.modal_company = true
			this.request({ pagination: this.server_pagination })
		},

		removeStore() {
			let companyBranches = this.company_branches
			this.company_branches_remove.map((e) => {
				let i = companyBranches.indexOf(e.id)
				if (i > -1) {
					companyBranches.splice(i, 1)
				}
			})
			this.$store.dispatch('campaigns/SET_COMPANY_BRANCHES', [companyBranches])
			this.saveCampaigns()
			this.company_branches_remove = []
		},

		saveStore() {
			let items = this.company_branches_add.map((item) => item.id)
			this.$store.dispatch('campaigns/SET_COMPANY_BRANCHES', [
				[...items, ...this.company_branches],
			])
			this.company_branches_add = []
			this.saveCampaigns()
		},

		saveCampaigns() {
			this.$q.loading.show()
			let data = {
				title: this.title,
				sub_title: this.sub_title,
				description: this.description,
				campaign_url: this.campaign_url,
				start_date: moment(this.start_date).format('YYYY-MM-DD'),
				end_date: moment(this.end_date).format('YYYY-MM-DD'),
				image: this.image,
				image_banner: this.image_banner,
				areas: this.area,
				profiles: this.profile,
				status: this.status,
				company_branches: this.company_branches,
				brands: this.brands,
				product_types: this.product_types,
				products: this.products,
				rewards: this.rewards,
				allow_sells: this.allow_sells,
				training_kpi_points: this.training_kpi_points,
				training_non_kpi_points: this.training_non_kpi_points,
			}

			this.$axios
				.put(`/admin_rewards/campaigns/${this.id}/`, data, this.getHeader)
				.then(() => {
					this.server_pagination.rowsPerPage = this.num_rows
					this.modal_company = false
					this.request_selected({ pagination: this.server_pagination_selected })
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		savePagination() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [
				this.server_pagination_selected.rowsPerPage,
			])
		},

		loadPagination() {
			this.server_pagination_selected.rowsPerPage = this.num_rows
		},
	},

	created() {
		this.loadPagination()
		this.request_selected({ pagination: this.server_pagination_selected })
	},
}
</script>

<style></style>
